import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { closeAllModals } from "@store/slices/modalSlice";
import Modal from "@components/modals/Modal";
import { createProject } from "@store/thunks/dashboardThunk";
import { toast } from "react-toastify";

const CreateProject = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isOpen = useSelector((state) => state.modal.createProject);
  const [projectName, setProjectName] = useState("");
  const [description, setDescription] = useState("");
  const [deadline, setDeadline] = useState("");

  const getActiveTab = () => {
    if (location.pathname.includes("/superAdmin/ga")) return "GA";
    if (location.pathname.includes("/superAdmin/devnagri")) return "devnagri";
    return "GA";
  };

  const handleClose = () => {
    dispatch(closeAllModals("createProject"));
    setProjectName("");
    setDescription("");
    setDeadline("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const projectDetails = { projectName, description, deadline };
    try {
      const result = await dispatch(createProject(getActiveTab(), projectDetails));
      console.log(result)
      if (result.status === 'success') {
        handleClose();
        toast.success("Project created successfully!");
      } else {
        console.log(result)
        const errorMessage = result.message || "Failed to create project";
        toast.error(errorMessage);
      }
    } catch (err) {
      console.error("Create project error:", err);
      toast.error("Unexpected error while creating project");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Create New Project"
      maxWidth="md"
    >
      <div className="bg-white rounded-lg shadow-lg">
        {/* Form Section */}
        <div className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Project Name Field */}
            <div className="space-y-2">
              <label
                htmlFor="projectName"
                className="block text-sm font-semibold text-gray-800 tracking-wide"
              >
                Project Name <span className="text-[#ff6d1e]">*</span>
              </label>
              <input
                id="projectName"
                type="text"
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
                required
                placeholder="Enter project name"
                className="w-full px-4 py-3.5 border border-gray-200 rounded-lg bg-white text-gray-800 text-sm placeholder-gray-400 focus:border-[#ff6d1e] focus:ring-2 focus:ring-[#ff6d1e]/20 hover:border-[#ff6d1e]/50 focus:outline-none transition-all duration-200"
              />
            </div>

            {/* Description Field */}
            <div className="space-y-2">
              <label
                htmlFor="description"
                className="block text-sm font-semibold text-gray-800 tracking-wide"
              >
                Description <span className="text-[#ff6d1e]">*</span>
              </label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                placeholder="Write project description here..."
                rows="4"
                className="w-full px-4 py-3.5 border border-gray-200 rounded-lg bg-white text-gray-800 text-sm placeholder-gray-400 resize-y min-h-[120px] focus:border-[#ff6d1e] focus:ring-2 focus:ring-[#ff6d1e]/20 hover:border-[#ff6d1e]/50 focus:outline-none transition-all duration-200"
              />
            </div>

            {/* Deadline Field */}
            <div className="space-y-2">
              <label
                htmlFor="deadline"
                className="block text-sm font-semibold text-gray-800 tracking-wide"
              >
                Deadline <span className="text-[#ff6d1e]">*</span>
              </label>
              <input
                id="deadline"
                type="date"
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
                required
                min={new Date(Date.now() + 86400000).toISOString().split("T")[0]}
                className="w-full px-4 py-3.5 border border-gray-200 rounded-lg bg-white text-gray-800 text-sm font-['Semantic/Strong'] focus:border-[#ff6d1e] focus:ring-2 focus:ring-[#ff6d1e]/20 hover:border-[#ff6d1e]/50 focus:outline-none transition-all duration-200 cursor-pointer [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-60 hover:[&::-webkit-calendar-picker-indicator]:opacity-100"
              />
            </div>

            {/* Action Buttons */}
            <div className="pt-8">
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-6 py-2.5 bg-white border border-gray-200 text-gray-600 text-sm font-medium rounded-lg hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-2.5 bg-[#ff6d1e] border border-[#ff6d1e] text-white text-sm font-medium rounded-lg hover:bg-[#ff6d1e]/90 focus:outline-none focus:ring-2 focus:ring-[#ff6d1e]/20 transition-all duration-200 transform hover:-translate-y-0.5"
                >
                  Create Project
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default CreateProject;